import cn from 'classnames';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import styles from './RolesCard.module.scss';
import Icon from 'Components/Icon/Icon';

export type RolesCardProps = {
  icon: ReactNode;
  label: string;
  value: string | number;
  tooltip?: string;
  valueColor?: 'blue' | 'green' | 'red' | 'default';
  className?: string;
};

function RolesCard({
  icon,
  label,
  value,
  tooltip,
  valueColor = 'default',
  className,
}: RolesCardProps) {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.header}>
        <div className={styles.iconBox}>{icon}</div>
        {tooltip && (
        <Tooltip title={tooltip}>
        <span className={styles.infoIcon}>
          <Icon type="exclamationCircle" size='md'/>
        </span>
      </Tooltip>
        )}
      </div>
      <div className={styles.label}>{label}</div>
      <div className={cn(styles.value, styles[valueColor])}>{value}</div>
    </div>
  );
}

export default RolesCard;